module.exports = __webpack_public_path__ + "images/icons_v2/volume-low-outlined-4bf36339.svg";